<!-- @format -->

<sis-description-list-compact>
  @if (courseUnit.possibleAttainmentLanguages?.length > 0) {
    <ng-template #compactListItem>
      <dt class="label colon">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.POSSIBLE_ATTAINMENT_LANGUAGES" | translate }}</dt>
      @for (languageUrn of courseUnit.possibleAttainmentLanguages; track languageUrn; let isLast = $last) {
        <dd class="value">
          {{ languageUrn | codeLocalizedName | async }}
          @if (!isLast) {
            <span>,&nbsp;</span>
          }
        </dd>
      }
    </ng-template>
  }

  @if (courseUnit.gradeScaleId) {
    <ng-template #compactListItem>
      <dt class="label colon">{{ "STUDIES.COURSE_UNITS_BASICINFO.GRADE_SCALE" | translate }}</dt>
      <dd class="value">
        {{ courseUnit.gradeScaleId | gradeScale | async | entityName | localizedString }}
      </dd>
    </ng-template>
  }

  @if (courseUnit.courseUnitType) {
    <ng-template #compactListItem>
      <dt class="label colon">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_UNIT_TYPE" | translate }}</dt>
      <dd class="value">
        {{ courseUnit.courseUnitType | codeLocalizedName | async }}
      </dd>
    </ng-template>
  }

  @if (courseUnit.studyLevel) {
    <ng-template #compactListItem>
      <dt class="label colon">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.STUDY_LEVEL" | translate }}</dt>
      <dd class="value">
        {{ courseUnit.studyLevel | codeLocalizedName | async }}
      </dd>
    </ng-template>
  }

  @if (courseUnit.organisations?.length > 0) {
    <ng-template #compactListItem>
      <dt class="label colon">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.ORGANIZER" | translate }}</dt>
      @for (organisation of courseUnit.organisations; track organisation; let isLast = $last) {
        <dd class="value">
          @if (organisation.organisationId) {
            <span>{{ organisation.organisationId | organisation | async | entityName | localizedString }}</span>
          }
          @if (organisation.educationalInstitutionUrn) {
            <span>{{ organisation.educationalInstitutionUrn | codeLocalizedName | async }}</span>
          }
          @if (!isLast) {
            <span>,&nbsp;</span>
          }
        </dd>
      }
    </ng-template>
  }

  @if (courseUnit.universityOrgIds?.length > 0) {
    <ng-template #compactListItem>
      <dt class="label colon">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.UNIVERSITY" | translate }}</dt>
      @for (universityId of courseUnit.universityOrgIds; track universityId; let isLast = $last) {
        <dd class="value">
          {{ universityId | organisation | async | entityName | localizedString }}
          @if (!isLast) {
            <span>,&nbsp;</span>
          }
        </dd>
      }
    </ng-template>
  }

  @if (courseUnit.cefrLevel) {
    <ng-template #compactListItem>
      <dt class="label colon">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.CEFR_LEVEL" | translate }}</dt>
      <dd class="value">
        {{ courseUnit.cefrLevel | codeLocalizedName | async }}
      </dd>
    </ng-template>
  }
</sis-description-list-compact>
